import constants from 'constants';
const {
  ADD_SUBSCRIPTIONS,
  JOIN_WEBINAR_FROM_LINK_SAGA
} = constants;

export const addSubscriptions = (subscriptions) => ({
  type: ADD_SUBSCRIPTIONS,
  subscriptions
})

export const joinWebinarFromLinkSaga = (webinarId) => ({
  type: JOIN_WEBINAR_FROM_LINK_SAGA,
  webinarId
})



/** WEBPACK FOOTER **
 ** ./src/actions/subscriptions.js
 **/